function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 22.5,
  fill: "white",
  stroke: "#2E3545",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.975 19.9749C19.975 21.2727 18.9229 22.3249 17.625 22.3249C16.3272 22.3249 15.275 21.2727 15.275 19.9749C15.275 18.677 16.3272 17.6249 17.625 17.6249C18.9229 17.6249 19.975 18.677 19.975 19.9749ZM31.725 19.9749C31.725 21.2727 30.6729 22.3249 29.375 22.3249C28.0772 22.3249 27.025 21.2727 27.025 19.9749C27.025 18.677 28.0772 17.6249 29.375 17.6249C30.6729 17.6249 31.725 18.677 31.725 19.9749ZM14.6475 32.5767C14.4689 33.0993 14.7479 33.6677 15.2705 33.8462C15.7932 34.0247 16.3616 33.7458 16.5401 33.2231C16.8316 32.3697 17.3988 31.3791 18.4435 30.5991C19.4817 29.8241 21.0678 29.1999 23.5002 29.1999C25.9327 29.1999 27.5188 29.8241 28.557 30.5991C29.6017 31.3791 30.1689 32.3697 30.4604 33.2231C30.6389 33.7458 31.2073 34.0247 31.7299 33.8462C32.2526 33.6677 32.5316 33.0993 32.353 32.5767C31.9595 31.4245 31.185 30.0652 29.7534 28.9965C28.3154 27.9229 26.2908 27.1999 23.5002 27.1999C20.7097 27.1999 18.6851 27.9229 17.247 28.9965C15.8155 30.0652 15.041 31.4245 14.6475 32.5767Z",
  fill: "#2E3545"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 60.2749,
  cy: 23.5,
  r: 22.5,
  fill: "white",
  stroke: "#2E3545",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.5 19.975C68.5 21.2729 67.4479 22.325 66.15 22.325C64.8522 22.325 63.8 21.2729 63.8 19.975C63.8 18.6771 64.8522 17.625 66.15 17.625C67.4479 17.625 68.5 18.6771 68.5 19.975ZM56.7502 19.975C56.7502 21.2729 55.698 22.325 54.4002 22.325C53.1023 22.325 52.0502 21.2729 52.0502 19.975C52.0502 18.6771 53.1023 17.625 54.4002 17.625C55.698 17.625 56.7502 18.6771 56.7502 19.975ZM53.225 29.375C52.5761 29.375 52.05 29.9011 52.05 30.55C52.05 31.1989 52.5761 31.725 53.225 31.725H67.3251C67.974 31.725 68.5 31.1989 68.5 30.55C68.5 29.9011 67.974 29.375 67.3251 29.375H53.225Z",
  fill: "#2E3545"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 97.05,
  cy: 23.5,
  r: 22.5,
  fill: "#F3FCFF",
  stroke: "#00BAFF",
  strokeWidth: 2
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.925 22.325C104.223 22.325 105.275 21.2729 105.275 19.975C105.275 18.6771 104.223 17.625 102.925 17.625C101.627 17.625 100.575 18.6771 100.575 19.975C100.575 21.2729 101.627 22.325 102.925 22.325ZM91.175 22.325C92.4728 22.325 93.525 21.2729 93.525 19.975C93.525 18.6771 92.4728 17.625 91.175 17.625C89.8771 17.625 88.825 18.6771 88.825 19.975C88.825 21.2729 89.8771 22.325 91.175 22.325Z",
  fill: "#00BAFF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M105.275 28.2H88.825C88.825 28.2 90 35.25 97.05 35.25C104.1 35.25 105.275 28.2 105.275 28.2Z",
  stroke: "#00BAFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 47,
    viewBox: "0 0 121 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.d59b11c0.svg";
export { ForwardRef as ReactComponent };